/* Geartracking: shared add-to-cart helper for gt-* sections. */
(function () {
  if (window.gtCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      // Match the store's Liquid money format for euros (€2.006,00).
      var loc = cur === 'EUR' ? 'nl-NL' : (document.documentElement.lang || 'en');
      return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100).replace(/^€\s/, '€');
    } catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  function add(items, opts) {
    opts = opts || {};
    var btn = opts.button, status = opts.status;
    items = (items || []).filter(function (i) { return i && i.id && i.quantity > 0; });
    if (!items.length) { if (status) status.textContent = opts.emptyText || 'Choose a quantity first.'; return Promise.resolve(); }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (status) status.textContent = 'Adding…';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to cart');
        if (opts.redirect) { window.location.href = root + 'cart'; return; }
        if (opts.reload) { window.location.reload(); return; }
        if (status) status.innerHTML = 'Added. <a href="' + root + 'cart">View cart</a>';
        fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
          var el = document.getElementById('cart-icon-bubble');
          if (el && s['cart-icon-bubble']) {
            var tmp = document.createElement('div'); tmp.innerHTML = s['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section'); el.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
          }
        }).catch(function () {});
      })
      .catch(function (e) { if (status) status.textContent = e.message; })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }
  window.gtCart = { add: add, money: money };
})();
